import React from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Grid, TextareaAutosize, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import fileDownload from 'js-file-download'
import ItemsList from '../orders/ItemsList'
import legolasApi from '../../api/legolas'

function InvoiceDetails() {
  //const { state : {  source } } = useLocation()
  // const navigate = useNavigate()
  // const [orderData, setOrderData] = React.useState(null)
  // const [openAlert, setOpenAlert] = React.useState(false)
  // const [alertText, setAlertText] = React.useState('')
  // React.useEffect(() => {
  //   axios.get(`${legolasApi.url}/orders/${data.orderId}`).then((res) => {
  //     setOrderData(res.data.data)
  //   })
  // },[])
  const { id: orderId } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const source = state?.source || null; // <-- safe access
  const [orderData, setOrderData] = React.useState(null);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertText, setAlertText] = React.useState('');
  const [data, setData] = React.useState(null); // New: data object like before
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
 React.useEffect(() => {
  if (!orderId) return;

  axios.get(`${legolasApi.url}/orders/${orderId}`).then((res) => {
    const response = res.data.data;
      const channelId = String(response?.summary?.channel_id);

      if (!userChannels.includes(channelId)) {
      setAlertText('You are not authorized to view this invoice.');
      setOpenAlert(true);
      setOrderData(null); 
      return;
    }

    setOrderData(response);
    setData({
      orderId: response?.summary?.order_id,
      invoiceNumber: response?.summary?.invoice_number || `INV-${orderId}`
    });
  }).catch((err) => {
    console.error('Error fetching order:', err);
    setAlertText('Failed to load invoice data.');
    setOpenAlert(true);
  });
}, [orderId]);



  //integrate pdf generation here
  const createPdf = async () => {
    const pdfPayload = { 
      invoiceNumber: data.invoiceNumber,
      vatNumber: '300101252300003',
      orderNumber: orderData.summary.order_id,
      orderDate: orderData.summary.placedOn,
      billingAddress: shipment,
      shippingAddress: shipment,
      paymentMethod: transaction,
      shippingMethod: orderData.summary.shipping_name,
      items,
      discount: orderData.summary.discount_amount,
      codFee: orderData.summary.cod_fee_incl_tax,
      subtotal: orderData.summary.subtotal_incl_tax,
      totalTax: orderData.summary.total_tax,
      shipping: orderData.summary.shipping_incl_tax,
      Price: orderData.summary.total_price,
      TotalSavings: (parseFloat(orderData.summary.total_discount) || 0) + (parseFloat(orderData.summary.discount_amount) || 0),
      grandTotal: orderData.summary.grand_total,
      payment_id: parseInt(orderData.summary.fk_payment_id),
      tamaraFee: orderData.summary.tamara_fee_incl_tax,
      tabbyFee: orderData.summary.tabby_fee_incl_tax,
      channel:orderData.summary.channel_id,
      totalOrderQty: orderData.summary.total_qty_ordered,
      poNumber: orderData.summary.po_number,
      BuyerVatNumber: orderData.summary.vat_number,
      adminOrderSource: orderData.summary.admin_order_source
    }
    if (Number(orderData.summary.one_day_delivery_charge) > 0) {
      pdfPayload.one_day_delivery_charge = parseFloat(orderData.summary.one_day_delivery_charge);
    }
    const generatePdfResponse = await axios.post(`${legolasApi.url}/admin/generate-pdf`, pdfPayload, { responseType: 'blob' });
    if (generatePdfResponse.status == 200) {
      //console.log("generatePdfResponse",generatePdfResponse)
      const contentType = generatePdfResponse.headers['content-type'];

      if (contentType?.includes('application/json')) {
        const text = await generatePdfResponse.data.text();
        const errorResp = JSON.parse(text);

        if (errorResp.success === false) {
          alert(errorResp.error || 'Failed to generate invoice PDF');
          return;
        }
      }
      const invoiceNumber = orderData.summary.order_id
      fileDownload(generatePdfResponse.data, `${invoiceNumber}.pdf`);
      const removeResp = await axios.post(`${legolasApi.url}/admin/invoice/remove`, {orderId: orderData.summary.order_id});
      if(removeResp.data && removeResp.data.success){
        console.log("invoice file removed successfully");
      }else{
        console.log("Error while removing invoice file");
      }
    }else{
      console.log("failed to generate pdf", generatePdfResponse);
    }
    // axios({
    //   url: `${legolasApi.url}/admin/generate-pdf`,
    //   method: 'POST',
    //   data: pdfPayload,
    //   responseType: 'blob'
    // }).then((res) => {
    //   // console.log("PDF Result: ",res.data);
    //   const invoiceNumber = orderData.summary.order_id
    //   const fileTitle = invoiceNumber !== null ? invoiceNumber : 'invoice'
    //   fileDownload(res.data, `${fileTitle}.pdf`)
    // })
  }

  const sendEmail = () => {
    const emailPayload = { 
      customerName: orderData.customer.firstname,
      orderNumber: data.orderId,
      customerEmail: orderData?.summary?.guest_user_email ||  orderData.customer.email ,
      attachInvoice: false,
      channel:orderData.summary.channel_id
    }
    axios.post(`${legolasApi.url}/admin/send/mail`, emailPayload).then((res) => {
      const data = res.data
      console.log('send email: ', data)
      if (data.success && data.message) {
        const alertMsg = data.message + ' ' + `to ${emailPayload.customerEmail}`
        handleEmailAlert(alertMsg);
      }
    })
  }

  const printAndSendInvoice = async () => {
    const pdfPayload = { 
      invoiceNumber: data.invoiceNumber,
      vatNumber: '300101252300003',
      orderNumber: orderData.summary.order_id,
      orderDate: orderData.summary.placedOn,
      billingAddress: shipment,
      shippingAddress: shipment,
      paymentMethod: transaction,
      shippingMethod: null,
      items,
      discount: orderData.summary.discount_amount,
      codFee: orderData.summary.cod_fee_incl_tax,
      subtotal: orderData.summary.subtotal_incl_tax,
      totalTax: orderData.summary.total_tax,
      shipping: orderData.summary.shipping_incl_tax,
      Price: orderData.summary.total_price,
      TotalSavings: (parseFloat(orderData.summary.total_discount) || 0) + (parseFloat(orderData.summary.discount_amount) || 0),
      grandTotal: orderData.summary.grand_total,
      payment_id: parseInt(orderData.summary.fk_payment_id),
      tamaraFee: orderData.summary.tamara_fee_incl_tax,
      tabbyFee: orderData.summary.tabby_fee_incl_tax,
      channel:orderData.summary.channel_id,
      totalOrderQty: orderData.summary.total_qty_ordered,
      poNumber:orderData.summary.po_number,
      BuyerVatNumber:orderData.summary.vat_number,
      adminOrderSource :orderData.summary.admin_order_source

   }
     if (Number(orderData.summary.one_day_delivery_charge) > 0) {
      pdfPayload.one_day_delivery_charge = parseFloat(orderData.summary.one_day_delivery_charge);
    }
    const emailPayload = { 
      customerName: orderData.shipment['customer_firstname'],
      orderNumber: orderData.summary.order_id,
      customerEmail:orderData.summary.guest_user_email ||  orderData.customer.email,
      attachInvoice: true,
      channel:orderData.summary.channel_id
    }
    console.log("emailPayload", emailPayload);
    const generatePdfResponse = await axios.post(`${legolasApi.url}/admin/generate-pdf`, pdfPayload, {responseType: 'blob'});
    if(generatePdfResponse.status == 200){
      //console.log("generatePdfResponse",generatePdfResponse)
      const contentType = generatePdfResponse.headers['content-type'];

      if (contentType?.includes('application/json')) {
        const text = await generatePdfResponse.data.text();
        const errorResp = JSON.parse(text);

        if (errorResp.success === false) {
          alert(errorResp.error || 'Failed to generate invoice PDF');
          return;
        }
      }
      const invoiceNumber = orderData.summary.order_id
      fileDownload(generatePdfResponse.data, `${invoiceNumber}.pdf`);
      const emailResponse = await axios.post(`${legolasApi.url}/admin/send/mail`, emailPayload);
      if(emailResponse.data && emailResponse.data.success){
        console.log('email res', emailResponse);
        const removeResp = await axios.post(`${legolasApi.url}/admin/invoice/remove`, {orderId: orderData.summary.order_id});
        if(removeResp.data && removeResp.data.success){
          console.log("invoice file removed successfully");
        }else{
          console.log("Error while removing invoice file");
        }
      }else{
        console.log('Error while sending mail', emailResponse.data);
      }
    }else{
      console.log("failed to generate pdf", generatePdfResponse);
    }
  }

  const handleBackClick = () => {
    if (source == 'order-details') {
      navigate(`/orders/${orderId}`)
    } else {
      navigate('/invoices')
    }
  }



  const closeAlert = () => {
    setOpenAlert(false)
  }

  const handleEmailAlert = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }
  if (!orderData) return null;

  const darkBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#fff',
    padding: '10px'
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }

  const purchasedFromDefault = 'Shababuna Website'
  const purchasedIPDefault = 'NULL'
  if (orderData == null) {
    return
  }
  const { summary, shipment, transaction, items, customer } = orderData 
  // const computedGrandTotal = (parseFloat(summary.grand_total) || 0) + (parseFloat(summary.one_day_delivery_charge) || 0);

  const AddressInfo = () => {
    return (
      <React.Fragment>
        <Box sx={{ display: 'inline' }}>
          <Typography sx={{ paddingRight: '5px',wordBreak:"break-word " }}>{shipment.customer_firstname ? shipment.customer_firstname : null}</Typography>
          <Typography sx={{wordBreak:"break-word"}}>{shipment.customer_lastname ? shipment.customer_lastname : null}</Typography>
        </Box>
        <Typography sx={{wordBreak:"break-word"}}>{shipment.street ? shipment.street : null}</Typography>
        <Typography>{shipment.district ? shipment.district : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography>{shipment.city ? shipment.city : null}</Typography>,
          <Typography sx={{ paddingLeft: '5px' }}>{shipment.postcode ? shipment.postcode : 560034}</Typography>
        </Box>
        <Typography>{shipment.country ? shipment.country : null}</Typography>
        <Box sx={{ display: 'inline-flex'}}>
          <Typography sx={{ paddingRight: '5px' }}>T:</Typography>
          <Typography>{shipment.phone ? shipment.phone : null}</Typography>
        </Box>
      </React.Fragment>
    )
  }
  return (
    <Box sx={{ width: '97%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
       <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '2.5rem',
          fontWeight: 400,
          color: '#000'
        }}}>
          <Typography>#{data.orderId}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
        }}
        >
          <Button onClick={() => handleBackClick()}>Back</Button>
          <Button onClick={() => printAndSendInvoice()}>Print & Send Invoice</Button>
          {/* <Button onClick={() => sendEmail()}>Send Email</Button> */}
          <Button onClick={() => createPdf()}>Print</Button>
        </Box>
        <Box id='order-container'>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Order & Account Information</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Order # {orderData.summary.order_id} (The order confirmation email was sent)
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Order Status</Typography>
              {summary.order_status ?
              <Typography>{summary.order_status}</Typography> : <Typography sx={{ color: 'red' }}>Order status not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography> Next Day Delivery</Typography>
              <Typography>{Number(summary.one_day_delivery_charge) > 0 ? "True" : "False"}</Typography>
            </Box>
            {/*<Box sx={lightBox}>
              <Typography>Purchased From IP</Typography>
              {summary.order_ip ?
              <Typography>{summary.order_ip}</Typography> : <Typography>{purchasedIPDefault}</Typography>}
              </Box>*/}
            </Grid>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Account Information
              </Typography>
              <Box sx={darkBox}>
                <Typography>Customer Name</Typography>
                <Typography sx={{wordBreak:"break-word", marginLeft:"10px"}}>{shipment.customer_firstname + ' ' + shipment.customer_lastname}</Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Phone</Typography>
                {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
              </Box>
              <Box sx={darkBox}>
                <Typography>Customer Group</Typography>
                <Typography>GENERAL</Typography>
               {/* {customer.user_group_code ?
                <Typography>{customer.user_group_code}</Typography> : <Typography sx={{ color: 'red' }}>Group not set</Typography>}
               */}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Address Information
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Billing Address
            </Typography>
            <AddressInfo/>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping Address
            </Typography>
            <AddressInfo/>
          </Grid>
        </Grid>
      </Box>
      <Box id='paymentinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Payment & Shipping Method
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Payment Information
            </Typography>
            <Box>
              <Typography>{transaction.paymentType ? transaction.paymentType : null}</Typography>
                {
                  transaction.last4Digits && 
                  <Typography>
                    {transaction.last4Digits}
                  </Typography>
                }
              <Typography>{transaction.paymentBrand ? transaction.paymentBrand : null}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping & Handling Information
            </Typography>
            <Box>
              <Typography>
                {(summary.vinculumShipDetails != null) ? (summary.vinculumShipDetails[0].shipdetail[0].transporter) : 'Shababuna Shipping (default)'}
              </Typography>
            </Box>
            <Box>
              <Typography>Total Shipping Charges: <Typography sx={{ fontWeight: 700 }}>SAR {summary.shipping_incl_tax}</Typography></Typography>
            </Box>
          </Grid>
         </Grid>
      </Box>
      <Box id='itemsinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Items Invoiced
          </Typography>
        </Box>
        <Box>
          <ItemsList data={items ? items : []} source='order-info'/>
        </Box>
      </Box>
      <Box id='total-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Order Total</Typography>
          </Box>
          <Grid container spacing={5} columns={24} sx={{ flexDirection: 'row-reverse' }}>
            {/* <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Invoice History
              </Typography>
              <Box>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={5}
                placeholder="Invoice Comments"
                style={{ width: 500 }}
              />
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Invoice Totals
              </Typography>
              <Box sx={{ paddingBottom: '10px' }}>
              <Box sx={darkBox}>
                <Typography>Price</Typography>
                <Typography>SAR {summary.total_price ? parseFloat(summary.total_price).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
               </Box>        
              <Box sx={{ paddingBottom: '10px' }}>
                <Box sx={lightBox}>
                  <Typography>Subtotal (incl. Tax)</Typography>
                  <Typography>SAR {summary.subtotal_incl_tax ? parseFloat(summary.subtotal_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
                {Number(summary.total_discount) > 0 || Number(summary.discount_amount) > 0 ? (
                <>

                  <Box sx={{ display: 'flex', flexDirection: 'row', marginRight: '40px', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 400 } }}>
                    <Typography>Total Savings</Typography>
                    <Typography>
                      SAR {(
                        (parseFloat(summary.total_discount) || 0) + (parseFloat(summary.discount_amount) || 0)
                      ).toFixed(2)}
                    </Typography>
                  </Box>

                  <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: '8px', padding: '10px', marginTop: '5px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row',marginRight:'32px', justifyContent: 'space-between' ,paddingLeft: '10px', '& .MuiTypography-root': { fontSize: '12px', fontWeight: 500 } }}>
                      <Typography>Product Discount</Typography>
                      <Typography>SAR {(parseFloat(summary.total_discount) || 0).toFixed(2)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row',marginRight:'32px',justifyContent: 'space-between', paddingLeft: '10px', marginTop: '5px', '& .MuiTypography-root': { fontSize: '12px', fontWeight: 500 } }}>
                      <Typography>Coupon Discount</Typography>
                      <Typography>SAR {(parseFloat(summary.discount_amount) || 0).toFixed(2)}</Typography>
                    </Box>
                  </Box>

                </>
                
              ) : null}
                <Box sx={lightBox}>
                  <Typography>Tax</Typography>
                  <Typography>SAR {summary.total_tax ? parseFloat(summary.total_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              
              {/* <Box sx={darkBox}>
                <Typography>Coupon Discount</Typography>
                <Typography>SAR {summary.discount_amount ? parseFloat(summary.discount_amount).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
           */}
              <Box sx={darkBox}>
                <Typography>Shipping & Handling</Typography>
                <Typography>SAR {summary.shipping_incl_tax ? parseFloat(summary.shipping_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>

              <Box sx={lightBox}>
                <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                <Typography>SAR {summary.cod_fee_incl_tax ? parseFloat(summary.cod_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
              </Box>
              {
                parseInt(summary.fk_payment_id) === 5 &&
                <Box sx={darkBox}>
                  <Typography>Tamara Processing Fee</Typography>
                  <Typography>SAR {summary.tamara_fee_incl_tax ? parseFloat(summary.tamara_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              }
              {
                parseInt(summary.fk_payment_id) === 6 &&
                <Box sx={lightBox}>
                  <Typography>Tabby Processing Fee</Typography>
                  <Typography>SAR {summary.tabby_fee_incl_tax ? parseFloat(summary.tabby_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              }
              {Number(summary.one_day_delivery_charge) > 0 && (
                <Box sx={darkBox}>
                  <Typography>Next Day Delivery Fee</Typography>
                  <Typography>SAR {parseFloat(summary.one_day_delivery_charge).toFixed(2)}</Typography>
                </Box>
              )}
              <Box sx={lightBox}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>Grand Total</Typography>
                <Typography>SAR {summary.grand_total ? parseFloat(summary.grand_total).toFixed(2) : (0.00).toFixed(2)}</Typography>
                {/* <Typography>SAR {computedGrandTotal.toFixed(2)}</Typography> */}

              </Box>
            </Box>
            {/* <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button 
                  sx={{ 
                    backgroundColor: '#2b3f7a !important', 
                    borderRadius: 0, 
                    padding: '15px 20px', 
                    color: '#fff',
                    textTransform: 'capitalize'
                  }}
                  onClick={() => handleInvoiceSubmit()}
                >
                  Submit Invoice
                </Button>
              </Box> */}
              </Grid>
          </Grid>
        </Box>
    </Box>
  )
}

export default InvoiceDetails